// Privacy-friendly analytics: logs event name + optional props to our own
// database. No IP addresses, no user agents, no fingerprints, no third parties.
import { supabase } from "@/integrations/supabase/client";

type Props = Record<string, string | number | boolean | null | undefined>;

// Dedupe pageview-style events fired twice within a short window (e.g. React
// StrictMode double-mount in dev, or rapid re-renders).
const recent = new Map<string, number>();
const DEDUPE_MS = 1500;

export async function track(event: string, props: Props = {}): Promise<void> {
  try {
    const key = event + JSON.stringify(props ?? {});
    const now = Date.now();
    const last = recent.get(key);
    if (last && now - last < DEDUPE_MS) return;
    recent.set(key, now);

    const { data } = await supabase.auth.getSession();
    const userId = data.session?.user?.id ?? null;

    // Fire-and-forget — never block UI on analytics.
    await supabase.from("analytics_events").insert({
      event,
      props: props as never,
      user_id: userId,
    });
  } catch {
    // Swallow — analytics must never break the app.
  }
}
